import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { BackendService } from '../../../core/services/backend/backend.service';

export type WikiInfoResponse =
  | { success: true; data: string }
  | { success: false; message: string };

@Injectable({
  providedIn: 'root'
})
export class QueryAi {
  http = inject(HttpClient);
  backend = inject(BackendService);
  

  getWikiInfo(txt: string) {
    return this.http.post<WikiInfoResponse>(`${this.backend.getApiUrl()}/llm/wiki`, { text: txt });
  }
  
}
